const BLOCK_ROUTE = "ui/shared/route/BLOCK_ROUTE";
const UNBLOCK_ROUTE = "ui/shared/route/UNBLOCK_ROUTE";

export default {
  BLOCK_ROUTE,
  UNBLOCK_ROUTE,
};
